export default {
	entgratart: {
		notEntgraten: "Non sbavare",
		manually: "Manuale",
		oneSided: "Monolaterale (lato inferiore)",
		trowalisieren: "Burattatura",
		bothSides: "Bilaterale",
		undefinedState: "Non definito",
		notAvailable: "Non disponibile",
	},
	priceModel: {
		standard: "Veloce",
		slow: "Economico",
		express: "Express",
	},
	zincCoating: {
		none: "No",
		hotDip: "Zincato a caldo",
		galvanize: "Zincato galvanicamente",
		both: "Entrambi",
	},
	complainType: {
		outOfTolerance: "Dimensioni fuori tolleranza",
		wrongBending: "Piegatura difettosa",
		cutQualityLow: "Qualità di taglio non soddisfacente",
		scratches: "Superficie eccessivamente graffiata",
		missingCuts: "Tagli mancanti",
		wrongGrainDirection: "Direzione di satinatura errata",
		transportDamage: "Danno da trasporto",
		missing: "Parti mancanti nella consegna",
		powderCoating: "Verniciatura a polvere difettosa",
		weldline: "Cordone di saldatura difettoso",
		feature: "Filettatura, svasatura o imbutitura difettosa",
		other: "Altro reclamo",
		zincCoating: "Zincatura difettosa",
		wrongOrMissingPressJoin: "Inserto a pressione mancante o non conforme all'ordine",
	},
	complaintExpectationType: {
		ersatzlieferung: "Consegna sostitutiva",
		other: "Altra aspettativa...",
	},
};
